var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"label":"Plano de conta","dense":_vm.dense,"items":_vm.accountPlans,"item-text":_vm.itemText,"item-value":_vm.itemValue}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }